export default __webpack_public_path__ + "static/media/new-8.bd3b1cb7.png";